module.exports = __webpack_public_path__ + "static/media/perfil_prueba.b188c680.jpg";